import { getUserIdFromSupabaseUser } from '@/lib/auth-utils';
import { getSupabase } from '@/lib/supabase';
import type { SessionEvent, SessionId } from '@/schemas';
import { decodeRowToEvent } from './codec';
import { getSyncState, setLastDownloadedAt } from './state';

export interface DownloadResult {
  events: SessionEvent[];
}

export async function downloadRemoteEvents(sessionId: SessionId): Promise<DownloadResult> {
  const client = getSupabase();
  const {
    data: { session },
  } = await client.auth.getSession();
  if (!session?.user) {
    throw new Error('User must be authenticated to sync events');
  }

  const userId = getUserIdFromSupabaseUser(session.user);

  const { lastDownloadedAt = 0 } = await getSyncState(sessionId);
  const { data, error } = await client
    .from('session_events')
    .select<'*', import('./codec').EventRow>('*')
    .eq('session_id', sessionId)
    .eq('user_id', userId)
    .gt('timestamp', lastDownloadedAt)
    .order('timestamp', { ascending: true })
    .limit(1000);
  if (error) throw error;
  const events = (data ?? []).map((row) => decodeRowToEvent(row));
  if (events.length > 0) {
    await setLastDownloadedAt(sessionId, events.at(-1)!.timestamp);
  }
  return { events };
}
